var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-select',_vm._b({class:[
				_vm.transparent ? 'transparent-select' : 'ecommerce-select' ],attrs:{"outline":"","hide-details":"","menu-props":"auto","append-icon":"expand_more","items":_vm.items,"value":_vm.value},on:{"input":_vm.sendValue,"click:append-outer":_vm.clear}},'v-select',_vm.$attrs,false)),_vm._v(" "),_c('span',{staticClass:"err-message"},[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4043de87","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/inputs/app-select.vue
// module id = 829
// module chunks = 0 1 2 4 5 6 7 8 14 17